import { checkHoneypot } from "#app/utils/honeypot.server.ts";
import { getQuoteSession } from "#app/utils/get-a-quote/quote.server.ts";
import { Route } from "./+types/$step";
import { FormStep, formStepOrder, formSteps } from "#app/utils/get-a-quote/form-steps.ts";
import { QuoteForm } from "#app/components/get-a-quote/quote-form.tsx";
import { handleNextStepAction, handlePreviousStepAction, handleSubmitAction } from "#app/utils/get-a-quote/quote-utils.server.tsx";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { FormStepper, StepperItem } from "#app/components/form-stepper.tsx";
import { SEOHandle } from "@nasa-gcn/remix-seo";
import { Heading } from "#app/components/text.tsx";

export const handle: SEOHandle = {
  getSitemapEntries: () => null,
};

export const loader = async ({ request, params }: Route.LoaderArgs) => {
    const step = params.step;
    const session = getQuoteSession(request);
    return { session };
}

export const action = async ({ request, params }: Route.ActionArgs) => {
    const formData = await request.formData()
    await checkHoneypot(formData)
    const actionInput = QuoteForm.getFormInput(formData)
    const step = params.step as FormStep;
    const session = getQuoteSession(request);
    const formStep = formSteps[step]
    const schemaForHandler = formStep.schema;
    const currentStepIndex = formStepOrder.indexOf(step)
    switch (actionInput.action) {
        case QuoteForm.ACTIONS.NextStep: {
            return handleNextStepAction(session, formData, schemaForHandler, formStepOrder[currentStepIndex + 1]!);
        }
        case QuoteForm.ACTIONS.PreviousStep: {
            return handlePreviousStepAction(session, formStepOrder[currentStepIndex - 1]!);
        }
        case QuoteForm.ACTIONS.SubmitForm: {
            return handleSubmitAction(session, formData, schemaForHandler);
        }
        default: {
            return {
                error: "Invalid action"
            }
        }
    }
}

export default function QuoteFormStep({ loaderData }: Route.ComponentProps) {
    const session = loaderData.session
    const { step } = session
    const formStep = formSteps[step]
    const currentStepIndex = formStepOrder.indexOf(step)
    const progress = (currentStepIndex / (formStepOrder.length - 2)) * 100;
    const navigate = useNavigate();

    const renderStep = () => {
        const Component = formStep.component;
        if (!Component) {
            return null;
        }
        return (
            <Component session={session} />
        );
    }

    useEffect(() => {         
        void navigate(`/get-a-quote/${formStep.route}`);
    }, [step]);

    return (
        <main className="relative min-h-screen py-16">
            <div className="container">
                <Heading as="h1" className="mx-auto max-w-2xl mb-8 text-center text-h3">
                    Get a Free Quote
                </Heading>
                <FormStepper className="max-w-2xl mx-auto" currentStep={currentStepIndex}>
                    {Object.entries(formSteps).map(([key, step], index) => (
                        <StepperItem
                            key={key}
                            label={step.name}
                        />
                    ))}
                </FormStepper>
            </div>
            {renderStep()}
        </main>
    )
}